import { Component } from '@verndale/core';
import Headroom from 'headroom.js';
import Cookies from 'js-cookie';
import MakeHeaderAccessible from './make-header-accessible';
import FindACommunityHeader from './find-a-community-header';
import ScheduleATour from './schedule-a-tour-headless';
import HamburgerMenu from './hamburger-menu';
// import HeaderSearch from './header-search';
import { isEmpty, setLocalStorageData } from '../helpers';
import { BREAKPOINTS } from '../constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $header: this.el,
      $hamburger: this.el._$('.header__hamburger'),
      $hamburgerMenu: this.el._$('#hmenu'),
      $hamburgerMenuBanner: this.el._$('.hamburger-menu-banner'),
      $hamburgerMenuItemTitles: this.el._$$('.hamburger-menu__title-label'),
      $topLevelNavs: this.el._$('.header__top-level-navs'),
      $childNavWrapper: this.el._$('.header__child-nav-wrapper'),
      $closeHamburger: this.el._$('.header__close'),
      $findACommunityTrigger: this.el._$('.find-a-community-header-trigger'),
      $scheduleATourTrigger: this.el._$('.schedule-a-tour-trigger'),
      $closeChildNavTrigger: this.el._$('.header__back-to-top-level-trigger'),
      $primaryNavPanels: this.el._$$('.primary-nav__child-menu'),
      $menuItemHolder: this.el._$('.header__items-holder'),
      $utilityLanguage: this.el._$('.header__utility-language-item'),
      $dropDown: this.el._$('.header__utility-language-dropdown'),
      $utilityLanguageItems: this.el._$$(
        '.header__utility-language-dropdown-item'
      )
    };

    this.classes = {
      utilityOpen: 'header__utility-language-dropdown-open'
    };

    this.panelOpenedClass = 'header--panel-opened';
    this.childMenuPanelOpenedClass = 'header--child-menu-panel-opened';
    this.expandedPrimaryNavItemClass = 'primary-nav__item--expanded';
    this.openedPrimaryNavChildMenuClass = 'primary-nav__child-menu--opened';
    this.desktopMediaQuery = window.matchMedia('(min-width: 1200px)');
    this.isFullNav = this.desktopMediaQuery.matches;

    this.expanded = false;

    this.setup();

    if (!document.body.classList.contains("communityv2-landing-page")) {
      this.stick();
    }

    this.initSubModules();

    if (isEmpty(this.dom.$hamburgerMenuBanner)) {
      this.el._$$('.hamburger-menu-banner').forEach(el => {
        el.hidden = true;
      });
    }

    // this.HeaderSearch = new HeaderSearch(
    //   this.dom,
    //   this.lockScroll,
    //   this.unlockScroll
    // );

    const mainHeader = document.querySelector('header[data-module="header"]');
    if (mainHeader) {
      document.querySelector('html').style.scrollPaddingBlockStart = '150px';
      document.querySelector('body').style.scrollPaddingBlockStart = '150px';
    }
  }

  addListeners() {
    if (this.dom.$utilityLanguage) {
      this.dom.$utilityLanguage._on(
        'click',
        this.onToggleUtilityNavDropdown.bind(this)
      );
    }
    this.dom.$hamburger._on('click', this.handleHamburgerClick.bind(this));
    this.dom.$closeHamburger._on(
      'click',
      this.handleCloseHamburgerClick.bind(this)
    );
    this.dom.$primaryNavTriggers._on(
      'click',
      this.handlePrimaryNavTriggerClick.bind(this)
    );
    this.dom.$closeChildNavTrigger._on(
      'click',
      this.handleCloseChildNavTriggerClick.bind(this)
    );
    this.desktopMediaQuery.addEventListener('change', e => {
      this.isFullNav = e.matches;
    });
    document.addEventListener(
      'closeheader',
      this.closePrimaryNavChildMenu.bind(this)
    );
  }

  setup() {
    this.renderTopLevelHamburgerMenuItems();
    this.renderPrimaryNavTopLevelItems();
    this.renderHamburgerMenuInsideHamburgerNav();

    if (this.dom.$dropDown) {
      this.renderUtilityLanguageItems();
      this.changeSelectedLanguageLabel();
      this.addUtilityLanguageListener();
    }

    this.el.classList.add('header--loaded');
  }

  changeSelectedLanguageLabel() {
    if (!window.location.hostname.includes('.ca')) return;

    if (window.location.pathname.includes('/fr')) {
      this.dom.$utilityLanguage.textContent = this.dom.$utilityLanguageItems
        .find(item => item._$('a').getAttribute('href').includes('/fr'))
        ._$('.link__label').textContent;
    } else {
      this.dom.$utilityLanguage.textContent = this.dom.$utilityLanguageItems
        .find(item => item._$('a').getAttribute('href').includes('/en'))
        ._$('.link__label').textContent;
    }
  }

  handleHamburgerClick() {
    const insetHamburguer =
      parseFloat(getComputedStyle(this.dom.$menuItemHolder).marginRight, 10) *
      2;
    this.expanded = !this.expanded;
    this.dom.$hamburger.setAttribute('aria-expanded', this.expanded);

    this.el.classList.add(this.panelOpenedClass);
    this.lockScroll();
    this.scrollToHeader();

    this.dom.$hamburgerMenu.style.right = `-${insetHamburguer > 200 ? 0 : 0}px`;

    this.dom.$hamburgerMenu.focus();

    document._on('mousedown', this.handleListenToOutsideHanburger.bind(this));
    document.querySelector('header').style.position = 'sticky';
  }

  handleCloseHamburgerClick() {
    this.expanded = !this.expanded;
    this.dom.$hamburger.setAttribute('aria-expanded', this.expanded);

    this.el.classList.remove(this.panelOpenedClass);
    this.unlockScroll();
    this.closePrimaryNavChildMenu();
    this.displayPrimaryNavPanel();
  }

  handlePrimaryNavTriggerClick(e) {
    const item = e.target.closest('.primary-nav__item');
    const id = e.target.dataset.panel;

    if (item.classList.contains(this.expandedPrimaryNavItemClass)) {
      return this.closePrimaryNavChildMenu();
    }

    this.focusOutPrimaryNav();
    this.communityOrTour.focusOut();
    item.classList.add(this.expandedPrimaryNavItemClass);
    this.openPrimaryNavChildMenu();

    return this.displayPrimaryNavPanel(id);
  }

  handleCloseChildNavTriggerClick() {
    this.closePrimaryNavChildMenu();
  }

  handleListenToOutsidePrimaryNavPanel(e) {
    const hasClickedOutSidePanel = !this.dom.$childNavWrapper.contains(
      e.target
    );
    const hasClickedPrimaryNavTrigger =
      this.dom.$primaryNavTriggers.find(el => el.contains(e.target)) || true;
    const hasClickedFindACommunityTrigger =
      this.dom.$findACommunityTrigger?.contains?.(e.target);

    if (
      hasClickedOutSidePanel &&
      !hasClickedPrimaryNavTrigger &&
      !hasClickedFindACommunityTrigger
    ) {
      this.closePrimaryNavChildMenu();
    }
  }

  handleListenToOutsideHanburger(e) {
    if (!this.isFullNav) return;

    const hasClickedOutsidePanel = !this.dom.$hamburgerMenu.contains(e.target);

    if (hasClickedOutsidePanel) {
      this.handleCloseHamburgerClick();
    }
  }

  scrollToHeader() {
    const topScrollPros = document.documentElement.scrollTop;
    const headerScrollPos =
      this.dom.$header.getBoundingClientRect().top + topScrollPros;
    if (topScrollPros < headerScrollPos) {
      window.scrollTo({
        top: headerScrollPos,
        behavior: 'smooth'
      });
    }
  }

  lockScroll() {
    if (
      window.matchMedia(`(max-width: ${BREAKPOINTS.TABLET_LANDSCAPE - 1}px)`)
        .matches
    ) {
      _$('html').style.overflow = 'hidden';
      _$('body').style.overflow = 'hidden';
      _$('html').style.position = 'relative';
      _$('body').style.position = 'relative';
      _$('html').style.height = '100%';
      _$('body').style.height = '100%';
    }
  }

  unlockScroll() {
    _$('html').style.overflow = 'visible';
    _$('body').style.overflow = 'visible';
    _$('html').style.height = 'auto';
    _$('body').style.height = 'auto';
  }

  stick() {
    new Headroom(this.el, {
      offset: {
        up: this.el.offsetTop,
        down: this.el.offsetTop + this.el.offsetHeight
      },
      classes: {
        initial: 'header',
        pinned: 'header--visible',
        unpinned: 'header--hidden',
        top: '-',
        notTop: '-',
        bottom: '-',
        notBottom: '-',
        frozen: '-'
      },
      onPin: () => {
        const sidePanel = document.querySelector('header');
        if (!sidePanel?.classList.contains('header--panel-opened')) {
          document.body.classList.add('header--visible');
          document.body.classList.remove('header--hidden');
        }
      },
      onNotTop: () => {
        document.body.classList.add('header--passed');
      },
      onTop: () => {
        document.body.classList.remove('header--passed');
      },
      onUnpin: () => {
        const sidePanel = document.querySelector('header');
        if (!sidePanel?.classList.contains('header--panel-opened')) {
          document.body.classList.add('header--hidden');
          document.body.classList.remove('header--visible');
        }
      }
    }).init();
  }

  openPrimaryNavChildMenu() {
    this.el.classList.add(this.childMenuPanelOpenedClass);

    if (this.isFullNav) {
      document._on(
        'mousedown',
        this.handleListenToOutsidePrimaryNavPanel.bind(this)
      );
    }
  }

  closePrimaryNavChildMenu() {
    this.el.classList.remove(this.childMenuPanelOpenedClass);

    this.dom.$primaryNavItems
      .find(el => el.classList.contains(this.expandedPrimaryNavItemClass))
      ?.classList.remove(this.expandedPrimaryNavItemClass);
    this.communityOrTour.focusOut();
    document.removeEventListener(
      'click',
      this.handleListenToOutsidePrimaryNavPanel.bind(this)
    );
  }

  displayPrimaryNavPanel(id) {
    const panel = this.dom.$primaryNavPanels.find(el => el.id === id);
    this.dom.$primaryNavPanels.forEach(el =>
      el.classList.remove(this.openedPrimaryNavChildMenuClass)
    );

    panel?.classList?.add?.(this.openedPrimaryNavChildMenuClass);

    return panel;
  }

  focusOutPrimaryNav() {
    this.dom.$primaryNavItems.forEach(el =>
      el.classList.remove(this.expandedPrimaryNavItemClass)
    );
  }

  initSubModules() {
    new MakeHeaderAccessible({
      dom: this.dom,
      handlePrimaryNavTriggerClick:
        this.handlePrimaryNavTriggerClick.bind(this),
      closePrimaryNavChildMenu: this.closePrimaryNavChildMenu.bind(this)
    });

    const commonConfig = {
      dom: this.dom,
      openPrimaryNavChildMenu: this.openPrimaryNavChildMenu.bind(this),
      closePrimaryNavChildMenu: this.closePrimaryNavChildMenu.bind(this),
      displayPrimaryNavPanel: this.displayPrimaryNavPanel.bind(this),
      focusOutPrimaryNav: this.focusOutPrimaryNav.bind(this)
    };

    this.hamburgerMenu = new HamburgerMenu(commonConfig);

    if (Cookies.get('current_community')) {
      this.communityOrTour = new ScheduleATour(commonConfig);
    } else {
      const isCommunity = document.querySelector('.community-landing-page-coveo') || document.body.classList.contains('communityv2-landing-page');

      this.communityOrTour = isCommunity ? new ScheduleATour(commonConfig) : new FindACommunityHeader(commonConfig);
    }
  }

  renderPrimaryNavTopLevelItems() {
    const isCommunity = document.querySelector('.community-landing-page-coveo') || document.body.classList.contains('communityv2-landing-page');

    const $communityOrTour = isCommunity ? this.dom.$scheduleATourTrigger : this.dom.$findACommunityTrigger;

    const list = document.createElement('ul');
    list.role = 'menubar';
    list.classList.add('primary-nav');

    const items = this.dom.$primaryNavPanels
      .map((panel, i) => {
        const link = panel._$('.primary-nav__child-menu-title')?.textContent;

        if (!link) return '';

        return `
        <li class="primary-nav__item">
          <button
            class="primary-nav__trigger header__mobile-sub-panel-trogger"
            aria-haspopup="true"
            aria-expanded="false"
            data-panel="${panel.id}"
            tabindex="0"
          >
            ${link}
            <svg class="primary-nav__trigger-arrow--down" width="18" height="11" viewBox="0 0 18 11" aria-hidden="true"><use xlink:href="#arrow-down" /></svg>
            <svg class="primary-nav__trigger-arrow--right" width="11" height="18" viewBox="0 0 11 18" aria-hidden="true"><use xlink:href="#arrow-right" /></svg>
          </button>
        </li>
      `;
      })
      .join('');

    list.innerHTML = items;
    this.dom.$topLevelNavs.prepend(list);
    if (Cookies.get('current_community')) {
      this.dom.$topLevelNavs.append(this.dom.$scheduleATourTrigger);
    } else {
      if ($communityOrTour) this.dom.$topLevelNavs.append($communityOrTour);
    }

    this.dom.$primaryNavItems = this.el._$$('.primary-nav__item');
    this.dom.$primaryNavTriggers = this.el._$$('.primary-nav__trigger');
  }

  renderUtilityLanguageItems() {
    const currentHost = window.location.host;

    const list = document.createElement('ul');
    list.role = 'menubar';
    list.classList.add('header__utility-language-dropdown');

    const items = this.dom.$utilityLanguageItems
      .map((item, i) => {
        const link = item._$('a');
        const text = link._$('.link__label')?.textContent;
        const href = link?.href;
        let target = `${href}`;

        if (!text || !href) return '';

        if (!href.includes(currentHost)) {
          target = `${href}`;
        }

        return `
        <li class="header__utility-language-dropdown-item">
          <a
            class="link link--small"
            href="${target}"
            data-href="${target}"
          >
            ${text}
          </a>
        </li>
      `;
      })
      .join('');

    list.innerHTML = items;
    this.dom.$dropDown.replaceWith(list);
  }

  addUtilityLanguageListener() {
    this.dom.$utilityLanguageItems.forEach(item => {
      const link = item._$('a');
      const href = link?.dataset.href;

      link.addEventListener('click', () => {
        console.log(href, '< href');

        if (href.includes('fr')) {
          setLocalStorageData({ langPref: 'fr' });
        } else {
          setLocalStorageData({ langPref: 'en' });
        }

        window.location.replace(href);
      });
    });
  }

  renderTopLevelHamburgerMenuItems() {
    const list = document.createElement('ul');
    list.classList.add('hamburger-menu-items');
    list.role = 'menubar';

    const items = this.dom.$hamburgerMenuItemTitles
      .map(
        title => `
      <li class="hamburger-menu-items__item" role="none">
        <button class="hamburger-menu-items__trigger header__mobile-sub-panel-trogger">
          ${title.textContent}
          <svg class="primary-nav__trigger-arrow--down" width="18" height="11" viewBox="0 0 18 11" aria-hidden="true"><use xlink:href="#arrow-down" /></svg>
          <svg class="primary-nav__trigger-arrow--right" width="11" height="18" viewBox="0 0 11 18" aria-hidden="true"><use xlink:href="#arrow-right" /></svg>
        </button>
      </li>
    `
      )
      .join('');

    list.innerHTML = items;
    this.dom.$topLevelNavs.prepend(list);
  }

  renderHamburgerMenuInsideHamburgerNav() {
    if (!this.dom.$hamburgerMenuBanner) {
      this.el._$('.hamburger-menu').classList.add('hamburger-menu--no-banner');
      return;
    }

    const banner = document.createElement('div');
    banner.classList.add('hamburger-menu-banner');
    banner.innerHTML = this.dom.$hamburgerMenuBanner.innerHTML;
    this.dom.$hamburgerMenu.prepend(banner);
  }

  onToggleUtilityNavDropdown(e) {
    const dropdown = this.el._$('.header__utility-language-dropdown');

    e.preventDefault();
    if (dropdown.classList.contains(this.classes.utilityOpen)) {
      dropdown.classList.remove(this.classes.utilityOpen);
      return;
    }
    dropdown.classList.remove(this.classes.utilityOpen);
    dropdown.classList.add(this.classes.utilityOpen);
  }
}

export default Module;
